export const base_path = "/";
export const img_path = "/";
export const api_path = process.env.REACT_APP_BACKEND_URL || "https://localhost:4000";